// extracted by mini-css-extract-plugin
export default {"audioContainer":"AudioPlayer_audioContainer__ZHNba","playerControlsContainer":"AudioPlayer_playerControlsContainer__z-R8G"};